import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, FileText, Star } from 'lucide-react';
export function Offer() {
  return <section id="offer" className="bg-brand-dark py-24 text-white relative overflow-hidden" data-id="element-99">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-yellow/10 rounded-full blur-[100px] pointer-events-none" data-id="element-100" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white/5 border border-white/10 rounded-3xl p-8 sm:p-12 text-center backdrop-blur-sm shadow-2xl" data-id="element-102">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6 text-balance" data-id="element-103">
            Secure the standard of your business and protect your Superhost
            status.
          </h2>

          <p className="text-xl text-gray-300 mb-10" data-id="element-104">
            Get the entire protocol today for less than the cost of a Starbucks
            order.
          </p>

          <div className="bg-black/40 rounded-2xl p-8 mb-10 inline-block border border-white/5" data-id="element-105">
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-106">
              <span className="text-gray-500 line-through text-2xl font-display" data-id="element-107">
                $49.00
              </span>
              <span className="text-brand-yellow text-6xl sm:text-7xl font-display tracking-tight" data-id="element-108">
                $6.36
              </span>
            </div>
            <p className="text-gray-400 font-medium uppercase tracking-widest text-sm mt-2" data-id="element-109">
              One-Time Payment
            </p>
          </div>

          <div className="max-w-md mx-auto" data-id="element-110">
            <Button className="w-full" subtext="Instant PDF Access. Save your next turnover." data-id="element-111">
              Download the Protocol Now
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-6 sm:gap-12 mt-12 pt-10 border-t border-white/10" data-id="element-112">
            <div className="flex items-center gap-2 text-gray-400" data-id="element-113">
              <FileText className="w-5 h-5 text-brand-yellow" data-id="element-114" />
              <span className="text-sm font-medium" data-id="element-115">Instant Access PDF</span>
            </div>
            <div className="flex items-center gap-2 text-gray-400" data-id="element-116">
              <Star className="w-5 h-5 text-brand-yellow" data-id="element-117" />
              <span className="text-sm font-medium" data-id="element-118">
                Save Your Superhost Status
              </span>
            </div>
            <div className="flex items-center gap-2 text-gray-400" data-id="element-119">
              <ShieldCheck className="w-5 h-5 text-brand-yellow" data-id="element-120" />
              <span className="text-sm font-medium" data-id="element-121">Secure Checkout</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}